"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledIs = _interopRequireDefault(require("../../utils/styled-is"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _mixins = require("../../styles/mixins");
var _variables = require("../HBTextField/variables");
var _templateObject;
var fontWeightConverter = {
  normal: 400,
  semibold: 600,
  bold: 700
};
var Label = exports.Label = _styledComponents["default"].label.withConfig({
  displayName: "HBLabelstyles__Label",
  componentId: "sc-1kqzxp2-0"
})(["", ";", " display:block;user-select:none;margin:0;font-weight:", ";color:", ";", ""], _mixins.proximaNova, function (prop) {
  return _variables.fontSize[prop.size];
}, function (props) {
  return fontWeightConverter[props.fontWeight];
}, function (props) {
  return props.disabled ? _colors["default"].neutral400 : props.color;
}, (0, _styledIs["default"])('uppercase')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        text-transform: uppercase;\n    "]))));
//# sourceMappingURL=HBLabel.styles.js.map